import { Button } from 'antd';
import { OrganizationMetadata } from '@sonar-software/sonar-core';
import { useSalesforceAuth } from '@hooks';
import { FULL_ROUTES, QUERY, SETTINGS_ORGANIZATION_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useMemo } from 'react';

function getRedirectState(organizationId: number) {
	const current = new URL(window.location.href);

	current.searchParams.append(QUERY.ORGANIZATION, String(organizationId));

	return current.toString();
}

export interface ReauthenticationButtonProps {
	organization: OrganizationMetadata;
}

export const ReauthenticationButton: React.FC<ReauthenticationButtonProps> = ({ organization }) => {
	const redirectState = useMemo(() => getRedirectState(organization.id), [ organization.id ]);
	const { authRedirect, sandboxAuthRedirect } = useSalesforceAuth(FULL_ROUTES.INTEGRATIONS_SALESFORCE, redirectState);

	const handler = organization.isSandbox ? sandboxAuthRedirect : authRedirect;

	return <Button onClick={ handler }>{ SETTINGS_ORGANIZATION_COPY.REAUTHORIZE }</Button>;
};
